import { any } from 'bluebird';

interface PageInfo {
    hasPreviousPage?: boolean | null;
    hasNextPage?: boolean | null;
    endCursor?: string | null;
    startCursor?: string | null;
}

interface ConnectionNode<T = any> {
    edges?: T[] | null;
    pageInfo?: PageInfo | null;
}

export function mapBefore<T extends ConnectionNode<C>, C = any>(previousData: T | null, data?: T | null): T | null {
    if (!data) {
        return previousData;
    }

    const previous = (previousData || {}) as T;

    return {
        ...(previous as any),
        ...(data as any),
        edges: [...(data.edges || []), ...(previous.edges || [])],
        pageInfo: {
            ...data.pageInfo,
            endCursor: previous && previous.pageInfo && previous.pageInfo.endCursor,
            hasNextPage: previous && previous.pageInfo && previous.pageInfo.hasNextPage,
        },
    } as T;
}
export function mapAfter<T extends ConnectionNode<C>, C = any>(previousData: T | null, data?: T | null): T | null {
    if (!data) {
        return previousData;
    }

    const previous = (previousData || {}) as T;

    return {
        ...(previous as any),
        ...(data as any),
        edges: [...(previous.edges || []), ...(data.edges || [])],
        pageInfo: {
            ...data.pageInfo,
            startCursor: previous && previous.pageInfo && previous.pageInfo.startCursor,
            hasPreviousPage: previous && previous.pageInfo && previous.pageInfo.hasPreviousPage,
        },
    } as T;
}

export function removeFromQuery<T extends ConnectionNode<C>, C = any>(
    previousData: T | null,
    idToRemove: string,
    getIdFromNode: (Node: any) => string
): T | null {
    const previous = (previousData || {}) as T;
    previous.edges = previous.edges || [];
    console.log(previous);
    const edges = [...(previous.edges || [])];
    const indexOfId = previous.edges.findIndex(node => {
        return getIdFromNode(node) === idToRemove;
    });
    if (previous.edges.length === 0 || (previous.edges.length === 1 && indexOfId === 0)) {
        return {
            ...previous,
            edges: [] as C[],
            pageInfo: {
                ...previous.pageInfo,
                hasPreviousPage: previous && previous.pageInfo && previous.pageInfo.hasPreviousPage,
            },
        } as T;
    }
    edges.splice(indexOfId, 1);

    let endCursor;
    if (indexOfId === previous.edges.length) {
        endCursor = previous && previous.edges && previous.edges[previous.edges.length - 1].cursor;
    } else {
        endCursor = previous && previous.pageInfo && previous.pageInfo.endCursor;
    }

    return {
        ...previous,
        edges,
        pageInfo: {
            ...previous.pageInfo,
            hasNextPage: previous && previous.pageInfo && previous.pageInfo.hasNextPage,
            hasPreviousPage: previous && previous.pageInfo && previous.pageInfo.hasPreviousPage,
            // startCursor,
            endCursor,
        },
    };
}
